<template>
  <hel-module title="成本分析" :class="scope.clsPrefix" v-loading="loading">
    <!-- <template slot="extra">
      <span :class="['trend-badge', growthRate >= 0 ? 'trend-up' : 'trend-down']">
        {{ growthRate >= 0 ? '+' : '' }}{{ growthRate.toFixed(1) }}%
      </span>
    </template> -->
    <div class="cost-container">

      <div class="cost-content">
        <div class="chart-center-text">
        <div class="center-label">总成本</div>
        <div class="center-value">{{ totalAmount }}</div>
        <div class="center-unit">万</div>
      </div>
        <div id="analysis_costChart" class="cost-chart">
      </div>
      <div class="cost-list">
        <div class="list-item" v-for="(item, index) in costItems" :key="index">
          <div class="item-header">
            <span class="item-dot" :style="{ background: item.color }"></span>
            <span class="item-name">{{ item.name }}</span>
          </div>
          <div class="item-value">{{ item.value }}</div>
        </div>
      </div>
      </div>

    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import * as echarts from 'echarts'
import axios from 'axios'
export default {
  name: 'CostAnalysis',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-cost-analysis'
      },
      costItems: [
        { name: '材料成本', value: '7,223万', color: '#4a5ff3', percent: 73.7, amount: 7223 },
        { name: '人工成本', value: '1,030万', color: '#7D8EF5', percent: 10.5, amount: 1030 },
        { name: '制造费用', value: '1,550万', color: '#ABB6F9', percent: 15.8, amount: 1550 }
      ],
      totalAmount: '9,803',
      growthRate: -14.8
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.fetchCostAnalysis() // 暂时用 mock 数据，不走接口
      // this.drawChart()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 统一金额换算：接口单位为元 → 万元，保留两位小数 + 千分位
    // withSuffix: 是否带「万」字（中心值下方已有「万」字，传 false）
    toWan(value, withSuffix) {
      const num = Number(value) / 10000
      const text = num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      return withSuffix ? text + '万' : text
    },
    formatValue(value) {
      return this.toWan(value, true)
    },
    formatAmount(value) {
      // 总成本：换算为万元后取整 + 千分位（中心大字展示）
      const num = Math.round(Number(value) / 10000)
      return num.toLocaleString('en-US')
    },
    async fetchCostAnalysis() {
      this.loading = true
      try {
        const now = new Date()
        const year = now.getFullYear().toString()
        const month = (now.getMonth()).toString()
        // 'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/costAnalysis'

        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/erp/costAnalysis',
          {
            secret: '9k0NVP',
            paramList: [
              { paramName: 'year', paramValue: year },
              { paramName: 'month', paramValue: month }
            ]
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        console.log('成本分析接口返回:', response.data)

        if (response.data.code === 200 && response.data.data.length > 0) {
          const data = response.data.data[0]
          const totalCost = data.total_cost

          this.totalAmount = this.formatAmount(totalCost)
          this.growthRate = data.total_cost_growth_rate

          this.costItems = [
            {
              name: '原材料',
              value: this.formatValue(data.raw_material_cost),
              color: '#4a5ff3',
              amount: data.raw_material_cost
            },
            {
              name: '人工',
              value: this.formatValue(data.labor_cost),
              color: '#7D8EF5',
              amount: data.labor_cost
            },
            {
              name: '制造费用',
              value: this.formatValue(data.manufacturing_overhead),
              color: '#ABB6F9',
              amount: data.manufacturing_overhead
            },
            {
              name: '管理费用',
              value: this.formatValue(data.admin_expense),
              color: '#DADFFC',
              amount: data.admin_expense
            }
          ]

          this.$nextTick(() => {
            this.drawChart()
          })
        }
      } catch (error) {
        console.error('获取成本分析数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    drawChart() {
      const chart = echarts.init(document.getElementById('analysis_costChart'))
      const option = {
        color: ['#4a5ff3', '#7D8EF5', '#ABB6F9'],
        tooltip: {
          trigger: 'item',
          // 悬浮框约束在图表容器内：靠近边缘时自动调整位置，保证内容完整不被裁切
          confine: true,
          // 金额统一万元展示（两位小数 + 千分位），占比保持一位小数
          formatter: (params) =>
            `${params.name}: ${this.toWan(params.value, true)} (${params.percent}%)`
        },
        series: [
          {
            type: 'pie',
            radius: ['70%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              // borderRadius: 4
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.costItems.map((item) => ({
              value: item.amount,
              name: item.name,
              itemStyle: {
                color: item.color
              }
            }))
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-cost-analysis";
.#{$class-prefix} {
  .trend-badge {
    font-size: 12px;
    font-weight: 500;
    padding: 2px 8px;
    height: 16px;
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    &.trend-up {
      background: #F6FFED;
      color: #73B950;
    }
    &.trend-down {
      background: #FEEDED;
      color: #F44F4F;
    }
  }
  .cost-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 10px 0;
  }
  .chart-center-text {
      position: absolute;
      top: 50%;
      left: calc(50% - 85px);
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 1000;
      .center-label {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
    }
    .center-value {
      font-size: 24px;
      font-weight: 700;
      color: #333;
      // line-height: 36px;
    }
    .center-unit {
      font-size: 12px;
      color: #333;
      font-family: PingFangSC-Medium;
    }
    }
  .cost-chart {
    position: relative;
    width: 130px;
    height: 130px;
    flex-shrink: 0;
    margin-right: 32px;

  }
  .cost-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-header {
    // width: 100px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .item-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .item-name {
    font-size: 13px;
    color: #666666;
    font-weight: 400;
  }
  .item-value {
    font-size: 13px;
    color: #333333;
    font-weight: 600;
    text-align: left;
  }
}
.cost-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 300px;
  padding: 0px;
  // gap: 32px;
}
</style>
